var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, Badge, Button, Drawer, Image, Input, Popconfirm, Select, Table, Tabs, Tag, message, } from 'antd';
import { DeleteOutlined, EyeOutlined, ReloadOutlined, SearchOutlined, } from '@ant-design/icons';
import { useGetRestaurantsQuery } from '@/services/restaurantsApi';
import { useDeleteFeedPostAdminMutation, useGetFeedPostAdminQuery, useGetFeedPostsAdminQuery, useGetFeedReportedCountQuery, } from '@/services/feedApi';
import './FeedControlPage.scss';
var Option = Select.Option;
var formatDate = function (value) {
    return new Date(value).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};
var FeedControlPage = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = useState('all'), tab = _h[0], setTab = _h[1];
    var _j = useState(1), page = _j[0], setPage = _j[1];
    var _k = useState(''), searchInput = _k[0], setSearchInput = _k[1];
    var _l = useState(''), search = _l[0], setSearch = _l[1];
    var _m = useState(), restaurantId = _m[0], setRestaurantId = _m[1];
    var _o = useState(null), selectedPostId = _o[0], setSelectedPostId = _o[1];
    var _p = useGetRestaurantsQuery({}).data, restaurants = _p === void 0 ? [] : _p;
    var reportedCountData = useGetFeedReportedCountQuery().data;
    var _q = useGetFeedPostsAdminQuery({
        page: page,
        limit: 20,
        restaurantId: restaurantId,
        search: search || undefined,
        reportedOnly: tab === 'reported',
    }), data = _q.data, isLoading = _q.isLoading, isFetching = _q.isFetching, isError = _q.isError, error = _q.error, refetch = _q.refetch;
    var _r = useGetFeedPostAdminQuery(selectedPostId !== null && selectedPostId !== void 0 ? selectedPostId : 0, {
        skip: !selectedPostId,
    }), selectedPost = _r.data, detailLoading = _r.isLoading;
    var deletePost = useDeleteFeedPostAdminMutation()[0];
    var handleSearch = function () {
        setPage(1);
        setSearch(searchInput.trim());
    };
    var handleDelete = function (id) {
        return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, deletePost(id).unwrap()];
                    case 1:
                        _b.sent();
                        message.success('Пост удалён');
                        if (selectedPostId === id)
                            setSelectedPostId(null);
                        refetch();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        message.error('Не удалось удалить пост');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var errorDetail = isError && error && 'data' in error && error.data && typeof error.data === 'object' && 'message' in error.data
        ? String(error.data.message)
        : isError
            ? 'Проверьте, что API запущен и миграции ленты применены.'
            : '';
    var columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 70,
        },
        {
            title: 'Автор',
            key: 'author',
            width: 160,
            render: function (_, row) { return row.author.fullName || "ID ".concat(row.author.id); },
        },
        {
            title: 'Ресторан',
            key: 'restaurant',
            width: 180,
            ellipsis: true,
            render: function (_, row) {
                return row.restaurant ? (_jsx(Tag, __assign({ color: "purple" }, { children: row.restaurant.name }))) : (_jsx(Tag, { children: "\u041E\u0431\u0449\u0438\u0439 \u043F\u043E\u0441\u0442" }));
            },
        },
        {
            title: 'Текст',
            dataIndex: 'caption',
            ellipsis: true,
            render: function (value) { return value || '—'; },
        },
        {
            title: 'Медиа',
            dataIndex: 'mediaType',
            width: 90,
            align: 'center',
            render: function (value) {
                if (value === 'video')
                    return _jsx(Tag, __assign({ color: "blue" }, { children: "\u0432\u0438\u0434\u0435\u043E" }));
                if (value === 'image')
                    return _jsx(Tag, __assign({ color: "green" }, { children: "\u0444\u043E\u0442\u043E" }));
                return _jsx(Tag, { children: "\u0442\u0435\u043A\u0441\u0442" });
            },
        },
        {
            title: '♥ / 💬',
            key: 'stats',
            width: 100,
            align: 'center',
            render: function (_, row) { return "".concat(row.likesCount, " / ").concat(row.commentsCount); },
        },
        {
            title: 'Жалобы',
            dataIndex: 'reportsCount',
            width: 90,
            align: 'center',
            render: function (value) {
                return value > 0 ? _jsx(Badge, { count: value, style: { backgroundColor: '#ff4d4f' } }) : '—';
            },
        },
        {
            title: 'Дата',
            dataIndex: 'createdAt',
            width: 150,
            render: function (value) { return formatDate(value); },
        },
        {
            title: '',
            key: 'actions',
            width: 100,
            align: 'center',
            render: function (_, row) { return (_jsxs(_Fragment, { children: [_jsx(Button, { type: "text", icon: _jsx(EyeOutlined, {}), "aria-label": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435", onClick: function () { return setSelectedPostId(row.id); } }), _jsx(Popconfirm, __assign({ title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0441\u0442 \u0438\u0437 \u043B\u0435\u043D\u0442\u044B?", onConfirm: function () { return handleDelete(row.id); }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" }, { children: _jsx(Button, { type: "text", danger: true, icon: _jsx(DeleteOutlined, {}), "aria-label": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }) }))] })); },
        },
    ];
    return (_jsxs("div", __assign({ className: "FeedControlPage" }, { children: [_jsxs("div", __assign({ className: "titleBlock" }, { children: [_jsx("h1", { children: "\u041B\u0435\u043D\u0442\u0430" }), _jsx(Button, __assign({ icon: _jsx(ReloadOutlined, {}), onClick: function () { return refetch(); }, loading: isFetching }, { children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C" }))] })), _jsxs("div", __assign({ className: "FeedControlPage__content" }, { children: [_jsx(Tabs, { activeKey: tab, onChange: function (key) {
                            setTab(key);
                            setPage(1);
                        }, items: [
                            { key: 'all', label: 'Все посты' },
                            {
                                key: 'reported',
                                label: (_jsxs("span", { children: ["\u0421 \u0436\u0430\u043B\u043E\u0431\u0430\u043C\u0438", ((_a = reportedCountData === null || reportedCountData === void 0 ? void 0 : reportedCountData.count) !== null && _a !== void 0 ? _a : 0) > 0 && (_jsx(Badge, { count: reportedCountData === null || reportedCountData === void 0 ? void 0 : reportedCountData.count, style: { marginLeft: 8, backgroundColor: '#ff4d4f' } }))] })),
                            },
                        ] }), _jsxs("div", __assign({ className: "FeedControlPage__filters" }, { children: [_jsx(Input, { placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0442\u0435\u043A\u0441\u0442\u0443 \u0438\u043B\u0438 \u0430\u0432\u0442\u043E\u0440\u0443", value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, onPressEnter: handleSearch, style: { width: 280 }, allowClear: true }), _jsx(Button, __assign({ type: "primary", icon: _jsx(SearchOutlined, {}), onClick: handleSearch }, { children: "\u041D\u0430\u0439\u0442\u0438" })), _jsx(Select, __assign({ allowClear: true, placeholder: "\u0420\u0435\u0441\u0442\u043E\u0440\u0430\u043D", style: { width: 240 }, value: restaurantId, onChange: function (value) {
                                    setRestaurantId(value);
                                    setPage(1);
                                } }, { children: restaurants.map(function (r) { return (_jsx(Option, __assign({ value: r.id }, { children: r.name }), r.id)); }) }))] })), isError && (_jsx(Alert, { type: "error", showIcon: true, style: { marginBottom: 16 }, message: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043B\u0435\u043D\u0442\u0443", description: errorDetail, action: _jsx(Button, __assign({ size: "small", icon: _jsx(ReloadOutlined, {}), onClick: function () { return refetch(); } }, { children: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C" })) })), _jsx("div", __assign({ className: "FeedControlPage__card" }, { children: _jsx(Table, { rowKey: "id", loading: isLoading || isFetching, dataSource: (_b = data === null || data === void 0 ? void 0 : data.data) !== null && _b !== void 0 ? _b : [], columns: columns, pagination: {
                                current: page,
                                pageSize: 20,
                                total: (_c = data === null || data === void 0 ? void 0 : data.total) !== null && _c !== void 0 ? _c : 0,
                                showSizeChanger: false,
                                onChange: function (nextPage) { return setPage(nextPage); },
                            }, locale: {
                                emptyText: isError ? 'Нет данных — ошибка загрузки' : 'Постов пока нет',
                            } }) }))] })), _jsxs(Drawer, __assign({ title: selectedPost ? "\u041F\u043E\u0441\u0442 #".concat(selectedPost.id) : 'Пост', open: !!selectedPostId, onClose: function () { return setSelectedPostId(null); }, width: 520 }, { children: [detailLoading && _jsx("p", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." }), selectedPost && (_jsxs("div", __assign({ className: "FeedControlPage__detail" }, { children: [_jsxs("p", { children: [_jsx("strong", { children: "\u0410\u0432\u0442\u043E\u0440:" }), " ", selectedPost.author.fullName || "ID ".concat(selectedPost.author.id)] }), _jsxs("p", { children: [_jsx("strong", { children: "\u0420\u0435\u0441\u0442\u043E\u0440\u0430\u043D:" }), ' ', selectedPost.restaurant ? selectedPost.restaurant.name : 'Общий пост'] }), _jsxs("p", { children: [_jsx("strong", { children: "\u0414\u0430\u0442\u0430:" }), " ", formatDate(selectedPost.createdAt)] }), selectedPost.caption && (_jsx("p", __assign({ className: "FeedControlPage__caption" }, { children: selectedPost.caption }))), selectedPost.mediaType === 'image' && selectedPost.imageUrl && (_jsx(Image, { src: selectedPost.imageUrl, alt: "", style: { maxWidth: '100%', borderRadius: 8 } })), selectedPost.mediaType === 'video' && selectedPost.videoUrl && (_jsx("video", { src: selectedPost.videoUrl, controls: true, style: { width: '100%', borderRadius: 8 } })), _jsxs("p", { children: [_jsx("strong", { children: "\u041B\u0430\u0439\u043A\u0438 / \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438:" }), " ", selectedPost.likesCount, " / ", selectedPost.commentsCount] }), ((_e = (_d = selectedPost.reports) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0 && (_jsxs("div", __assign({ className: "FeedControlPage__reports" }, { children: [_jsxs("h3", { children: ["\u0416\u0430\u043B\u043E\u0431\u044B (", (_f = selectedPost.reports) === null || _f === void 0 ? void 0 : _f.length, ")"] }), (_g = selectedPost.reports) === null || _g === void 0 ? void 0 : _g.map(function (report) { return (_jsxs("div", __assign({ className: "FeedControlPage__reportItem" }, { children: [_jsxs("div", { children: [report.reporter.fullName || "ID ".concat(report.reporter.id), " \u00B7", ' ', formatDate(report.createdAt)] }), _jsx("div", { children: report.reason || 'Без комментария' })] }), report.id)); })] }))), _jsx(Popconfirm, __assign({ title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0441\u0442 \u0438\u0437 \u043B\u0435\u043D\u0442\u044B?", onConfirm: function () { return handleDelete(selectedPost.id); }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" }, { children: _jsx(Button, __assign({ danger: true, type: "primary", icon: _jsx(DeleteOutlined, {}) }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0441\u0442" })) }))] })))] }))] })));
};
export default FeedControlPage;
